const createRecommendation = ({
    title,
    category,
    simulator = null,
    defaultValues = {},
}) => ({ title, category, simulator, defaultValues });

export const categories = {
    realEstate: 'Produits immobiliers',
    financial: 'Produits financiers',
    financialCif: 'Produit financier',
};

const recommendations = {
    lifeInsurance: createRecommendation({ title: 'Assurance vie', category: 'financial', simulator: 'lifeInsurance' }),
    LODEOM: createRecommendation({ title: 'LODEOM', category: 'financial' }),
    FIP: createRecommendation({ title: 'FIP', category: 'financial' }),
    SCPI: createRecommendation({ title: 'SCPI', category: 'financial', simulator: 'scpi' }),
    dismemberedSCPI: createRecommendation({ title: 'SCPI démembrée', category: 'financial', simulator: 'dismemberedScpi' }),
    PER: createRecommendation({ title: 'PER', category: 'financial' }),
    PERP: createRecommendation({ title: 'PERP', category: 'financial' }),
    Madelin: createRecommendation({ title: 'Madelin', category: 'financial' }),
    diversification: createRecommendation({ title: 'Diversification', category: 'financial' }),
    otherFinancial: createRecommendation({ title: 'Autre', category: 'financial' }),
    Malraux: createRecommendation({ title: 'Malraux', category: 'realEstate' }),
    LMNP: createRecommendation({ title: 'LMNP classique', category: 'realEstate', simulator: 'lmnp' }),
    PinelDenormandie: createRecommendation({ title: 'Dispositif Denormandie', category: 'realEstate', simulator: 'pinelDenormandie' }),
    landDeficit: createRecommendation({ title: 'Déficit foncier', category: 'realEstate' }),
    otherRealEstate: createRecommendation({ title: 'Autre', category: 'realEstate' }),
    LODEOMCIF: createRecommendation({ title: 'LODEOM', category: 'financialCif' }),
    SCPIRendement: createRecommendation({ title: 'SCPI Rendement', category: 'financialCif' }),
    SCPIaCredit: createRecommendation({ title: 'SCPI à crédit',
        category: 'financialCif',
        defaultValues: {
            needFunding: true,
        } }),
    SCPIDemembreeCIF: createRecommendation({
        title: 'SCPI Démembrée',
        category: 'financialCif',
        defaultValues: {
            duration: 10,
        },
    }),
    privateRental: createRecommendation({
        title: 'Statut\nBailleur privé',
        category: 'realEstate',
        simulator: 'privateRental',
        defaultValues: {
            description: 'Statut bailleur privé – Neuf',
        },
    }),
};

export default recommendations;
